const VedgeSubscriptionsHandler = (function() {
  'use strict';

  const _debug = false;
  const sellingPlanMap = [];
  const discountPct = 15;

  let logicVersion = null;
  let controlType = 'radio';

  return {
    init,
    createSellingPlanInput,
    addListeners,
    addSellingPlanMapEntry,
    updateSellingPlanInput: _updateSellingPlanInput
  };

  ////////////////////////////////////////////////////////////////////////////

  function init(_logicVersion, _controlType) {
    logicVersion = _logicVersion;
    controlType = _controlType;
  }

  function createSellingPlanInput(form, value) {
    _deleteSellingPlanInput(form);

    var sellingPlanInput = document.createElement('input');
    sellingPlanInput.setAttribute('type','hidden');
    sellingPlanInput.setAttribute('name','selling_plan');
    sellingPlanInput.setAttribute('class','vedge_selling_plan_input');
    sellingPlanInput.setAttribute('value', value);

    form.appendChild(sellingPlanInput);
  }

  function addListeners(form) {
    const formVariantSelect = _findFormVariantSelect(form);
    if (formVariantSelect) {
      formVariantSelect.addEventListener("change", function() {
        _rebuildUiAfterVariantChange(form);
      });
    }

    const formChosenSellingPlanSelect = form.querySelector('select[id="chosen_selling_plan_id"]');
    if (formChosenSellingPlanSelect) {
      formChosenSellingPlanSelect.addEventListener("change", function() {
        _updateSellingPlanInput(form);
      });
    }

    const formOneTime = form.querySelector('input[id="selling_plan_onetime');
    if (formOneTime) {
      formOneTime.addEventListener("change", function() {
        _updateSellingPlanInput(form);
      });
    }

    const formSubscribe = form.querySelector('input[id="selling_plan_subscribe');
    if (formSubscribe) {
      formSubscribe.addEventListener("change", function() {
        _updateSellingPlanInput(form);
      });
    }
  }

  function addSellingPlanMapEntry(key, value) {
    sellingPlanMap[key] = value;

    if (_debug) {
      console.log(sellingPlanMap);
    }
  }

  ////////////////////////////////////////////////////////////////////////////

  function _rebuildUiAfterVariantChange(form) {
    const variantId = _findSelectedVariantId(form);

    _deleteChosenSellingPlanSelect(form);
    const formChosenSellingPlanSelect = form.querySelector('select[id="chosen_selling_plan_id"]');

    const plans = sellingPlanMap[variantId];

    plans.forEach (plan => {
      const sellingPlanId = plan.sellingPlanId;
      const label = plan.label;
      
      _addSelectOption(formChosenSellingPlanSelect, sellingPlanId, label);
    });

    _updateSellingPlanInput(form);
  }

  function _isSelectedOneTime(form) {
    const formOneTime = form.querySelector('input[id="selling_plan_onetime');

    return formOneTime.checked;
  }

  function _isSelectedSubscription(form) {
    const formSubscribe = form.querySelector('input[id="selling_plan_subscribe');

    return formSubscribe.checked;
  }

  function _updateSellingPlanInput(form) {

    const formChosenSellingPlanSelect = form.querySelector('select[id="chosen_selling_plan_id"]');
    const sellingPlanId = formChosenSellingPlanSelect.value;

    let shouldSubscribe = false;

    switch (controlType) {
      case 'radio':
        if (_isSelectedOneTime(form)) {
          _deleteSellingPlanInput(form);
        } else if (_isSelectedSubscription(form)) {
          shouldSubscribe = true;
          createSellingPlanInput(form, sellingPlanId);
        }

        break;
      case 'checkbox':
        if (!_isSelectedSubscription(form)) {
          _deleteSellingPlanInput(form);
        } else {
          shouldSubscribe = true;
          createSellingPlanInput(form, sellingPlanId);
        }

        break;
    }

    // dynamically change price
    const variantId = _findSelectedVariantId(form);

    const priceFull = VedgeProductPageHandler.getVariantPrice(variantId);
    const priceSub = Math.round(priceFull * 0.85, 2);

    const priceTextFull = '$' + priceFull/100;
    const priceTextSub = '$' + priceSub/100;

    let priceTextSelected = priceTextFull;
    if (shouldSubscribe) {
      priceTextSelected = priceTextSub;
    }

    _updatePriceElements(form, priceTextFull, priceTextSub, priceTextSelected);
  }

  function _updatePriceElements(form, priceTextFull, priceTextSub, priceTextSelected)
  {
    // controlled custom elements
    form.querySelectorAll('[data-price-text-type="full"').forEach(el => {
      el.innerHTML = priceTextFull;
    });

    form.querySelectorAll('[data-price-text-type="sub"').forEach(el => {
      el.innerHTML = priceTextSub;
    });

    form.querySelectorAll('[data-price-text-type="selected"').forEach(el => {
      el.innerHTML = priceTextSelected;
    });

    // other elements on page out of our control
    if (logicVersion === 'v3') {
      _runFunctionWithDelay(() => {
        // form.querySelector('div[data-product-type="price"]').innerHTML = priceTextSelected;
        form.querySelector('#AddToCart').innerHTML = priceTextSelected + ' - BUY NOW';
      });
    }
  }

  /**
   * Run a function and then run again after a delay.  This is useful if we want to update
   * page elements that get modified back by 3rd party code.  We can attempty to change again after
   * a short delay
   */
  function _runFunctionWithDelay(fn, delay = 1000)
  {
    fn();

    setTimeout(() => {
      fn();
    }, delay);
  }

  function _deleteSellingPlanInput(form) {
    const existingSellingPlanInput = form.querySelector('input[name="selling_plan"]');
    if (existingSellingPlanInput) {
      existingSellingPlanInput.remove();
    }
  }

  function _deleteChosenSellingPlanSelect(form) {
    const formChosenSellingPlanSelect = form.querySelector('select[id="chosen_selling_plan_id"]');
    if (formChosenSellingPlanSelect) {
      while (formChosenSellingPlanSelect.lastChild) {
        formChosenSellingPlanSelect.removeChild(formChosenSellingPlanSelect.lastChild);
      }
    }
  }

  function _addSelectOption(selectEl, value, label) {
    selectEl.options[selectEl.options.length] = new Option(label, value);
  }

  function _findFormVariantInput(form) {
    return form.querySelector('[name="id"]');
  }

  function _findFormVariantSelect(form) {
    let elSelect

    elSelect = form.querySelector('select[name="id"]');
    if (elSelect) {
      return elSelect;
    }

    elSelect = form.querySelector('select[data-key="Flavor"]');
    if (elSelect) {
      return elSelect;
    }
  }

  function _findSelectedVariantId(form)
  {
    const formVariantSelect = _findFormVariantInput(form);

    return formVariantSelect.value;
  }

})();
